import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    OnChanges,
    SimpleChanges,
} from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { ContextMenuComponent } from "ngx-contextmenu";
import { Subscription, Observable, Subject } from "rxjs";
import { buffer, debounceTime, filter, map } from "rxjs/operators";
import { IDmsConfig } from "../../interface/document.manager.interface";
import { DriveFile } from "../../models/DriveFile";
import { DocumentManagerService } from "../../services/document-manager.service";
import { ExtMap } from "../document-file-item/extension-map";
import { MyDrive, State } from "../document-list/document-list.component";
import { DocumentNewFolderDialogComponent } from "../document-new-folder-dialog/document-new-folder-dialog.component";
//import { EcapFileViewerModalComponent } from "../../../app-platform-file-viewer/components/ecap-file-viewer-modal/ecap-file-viewer-modal.component";
import { UserInfoService } from "@ecap3/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: "app-document-list-table-view",
    templateUrl: "./document-list-table-view.component.html",
    styleUrls: ["./document-list-table-view.component.scss"],
})
export class DocumentListTableViewComponent
    implements OnInit, OnDestroy, OnChanges {
    @Input() State: State;
    @Input() MyDrive: MyDrive;
    @Input() dmsConfig: IDmsConfig;
    @Input() UserId: any;
    @Output() SelectEvent = new EventEmitter<any>();
    displayedColumns = [
        "icon",
        "name",
        "type",
        "size",
        "created",
        "createdBy",
        "action",
    ];

    constructor(
        public userInfoService: UserInfoService,

        private documentManagerService: DocumentManagerService,
        private snackBar: MatSnackBar,
        public dialog: MatDialog,
        private translateService: TranslateService
    ) {
        this.FileRemoveSubscription =
            this.documentManagerService.onFileRemove.subscribe((Remove) => {
                if (Remove) {
                    this.init();
                }
            });

        this.TableChangeSubscription =
            this.documentManagerService.onTableViewChange.subscribe(
                (Change) => {
                    if (Change) {
                        this.init();
                    }
                }
            );
    }
    selected: any = null;
    dataSource: any[] = [];
    userInfo:any={}
    public RowBreakPoint: string = "xs";
    FileRemoveSubscription: Subscription;
    TableChangeSubscription: Subscription;
    clickStream: Subject<any> = new Subject<any>();

    @ViewChild(ContextMenuComponent)
    public basicMenu: ContextMenuComponent;
    colors = [
        "#69D2E7",
        "#A7DBDB",
        "#E0E4CC",
        "#F38630",
        "#FA6900",
        "#E94C6F",
        "#542733",
        "#5A6A62",
        "#C6D5CD",
        "#FDF200",
        "#DB3340",
        "#E8B71A",
        "#F7EAC8",
        "#1FDA9A",
        "#28ABE3",
        "#588C73",
        "#F2E394",
        "#F2AE72",
        "#D96459",
        "#8C4646",
        "#D0C91F",
        "#85C4B9",
        "#008BBA",
        "#E9514C",
        "#DC403B",
        "#00C8F8",
        "#59C4C5",
        "#FFC33C",
        "#FBE2B4",
        "#FF4C65",
    ];

    public Actions = {
        Select: (Document, Type) => {
            const idx = this.State.SelectedItemIds.indexOf(Document.ItemId);
            if (idx==-1) {
                this.State.SelectedItemIds.splice(this.State.SelectedItemIds.indexOf(Document.ItemId),1);
                Document.Type = Type;
                this.SelectEvent.emit(Document);
            }
            else{
                this.State.SelectedItemIds.push(Document.ItemId);
                Document.Type = Type;
                this.SelectEvent.emit(Document);
            }
        },
        OnClickOutside: (i, event) => {
            // Keeping the document highlighted if information button is clicked
            let buttonId = "";
            if ("parentNode" in event.target) {
                if (event.target.parentNode.id) {
                    buttonId = event.target.parentNode.id;
                } else {
                    buttonId = event.target.id;
                }
            }
            if (event.value && buttonId !== "information-icon-button") {
                this.State.SelectedItemIds = [];
            }
        },
        DoNothing: () => {
            return false;
        },
        DoubleClicked: (_Document) => {
            if (
                _Document["Type"] === "DriveFolder" ||
                _Document["Type"] === "SharedFolder"
            ) {
                this.documentManagerService.FolderEvent.next(
                    _Document["ItemIds"][0]
                );
            } else if (
                _Document["Type"] === "DriveFile" ||
                _Document["Type"] === "SharedFile"
            ) {
                this.documentManagerService.viewFile(
                    _Document.ItemIds[0],
                    true
                );
                // if (this.State.IsParentSecure) {
                //     this.documentManagerService.GetObjectArtifactById(_Document.ItemIds[0]).then(response => {
                //         this.dialog.open(EcapFileViewerModalComponent, {
                //             data: {
                //                 FileId: response[0].FileStorageId,
                //                 Secure: true
                //             }
                //         });
                //     });
                // }
            }
        },
        OnResized: ($event) => {
            const width = $event.newWidth;
            if (width >= 0 && width <= 599) {
                this.RowBreakPoint = "100"; // xs
            } else if (width >= 600 && width <= 1023) {
                this.RowBreakPoint = "33"; // sm
            } else if (width >= 1024 && width <= 1439) {
                this.RowBreakPoint = "25"; // md
            } else if (width >= 1440) {
                this.RowBreakPoint = "20"; // lg
            }
        },
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.dmsConfig) {
            if (this.dmsConfig && this.dmsConfig.hideFileSize) {
                this.displayedColumns = this.displayedColumns.filter(
                    (column) => column !== "size"
                );
            }
        }
    }

    ngOnInit() {
        this.init();
      

        // this.clickStream
        //     .pipe(buffer(this.clickStream.pipe(debounceTime(10)))
        //         , map((list: any, type) => {
        //             return { ItemIds: list, Length: list.length, Type: list[0].constructor.name };
        //         })
        //         , filter((x: any) => x.Length === 1))
        //     .subscribe((event) => {
        //         // this.Actions.Select(event.ItemIds[0], event.Type);
        //         this.Actions.DoubleClicked(event);
        //     });
        this.clickStream
            .pipe(
                buffer(this.clickStream.pipe(debounceTime(10))),
                map((list: any, type) => {
                    return {
                        ItemIds: list,
                        Length: list.length,
                        Type: list[0].Type,
                    };
                }),
                filter((x) => x.Length === 1)
            )
            .subscribe((event) => {
                this.Actions.Select(event.ItemIds[0], event.Type);
            });
        this.clickStream
            .pipe(
                buffer(this.clickStream.pipe(debounceTime(250))),
                map((list: any) => {
                    return {
                        ItemIds: list,
                        Length: list.length,
                        Type: list[0].Type,
                    };
                }),
                filter((x) => x.Length === 2)
            )
            .subscribe((event) => {
                // load Folder
                // console.log(event);
                this.Actions.DoubleClicked(event);
            });
    }
    share(Folder) {
        if (Folder.Type === "DriveFile" || Folder.Type === "SharedFile") {
            this.documentManagerService.documentShareEvent.emit({
                file: Folder,
                type: "File",
            });
        } else {
            this.documentManagerService.documentShareEvent.emit({
                folder: Folder,
                type: "Folder",
            });
        }
    }
    init() {
        if (this.dmsConfig && this.dmsConfig.hideFileSize) {
            this.displayedColumns = this.displayedColumns.filter(
                (column) => column !== "size"
            );
        }
        this.dataSource = [];
        if (this.MyDrive) {
            this.MyDrive.Folders.forEach((folder) => {
                this.dataSource.push(folder);
            });

            this.MyDrive.Files.forEach((file) => {
                file = this.AddImageFromFileExtension(file);
                this.dataSource.push(file);
            });
        }
        // console.log(this.dataSource);

        //Hack for smart city
        this.dataSource = this.dataSource.reduce((acc, current) => {
            let x: any = "";
            if (current.Type === "SharedFolder") {
                x = acc.find(
                    (item) =>
                        item.OriginalObjectArtifactId ===
                        current.OriginalObjectArtifactId
                );
            } else if (current.Type === "SharedFile") {
                x = acc.find(
                    (item) =>
                        item.OriginalArtifactId === current.OriginalArtifactId
                );
            }

            if (!x) {
                return acc.concat([current]);
            } else {
                return acc;
            }
        }, []);
    }

    AddImageFromFileExtension(_File: DriveFile) {
        let ext = _File.Name.split(".").pop();

        if (ext) {
            if (ext.length > 0) {
                ext = ext.toLowerCase();
                if (this.dmsConfig && this.dmsConfig.ExtMap) {
                    if (ext in this.dmsConfig.ExtMap) {
                        _File['IconName'] = this.dmsConfig.ExtMap[ext].IconName;
                    } else {
                        _File['IconName'] =
                            this.dmsConfig.ExtMap.default.IconName;
                    }
                } else if (ext in ExtMap) {
                    _File['IconName'] = ExtMap[ext].IconName;
                } else {
                    _File['IconName'] = ExtMap.default.IconName;
                }
            }
        }

        return _File;
    }

    onSelect(item) {
        this.selected = item;
        this.documentManagerService.onShowDetail.next(item);
    }

    download(item) {
        this.documentManagerService.changeworkingState("busy");
        this.documentManagerService.downloadFile(item.FileStorageId).then(
            (response) => {
                this.documentManagerService.changeworkingState("idle");
                if (!response.Status) {
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_DOWNLOADING_FILE"
                        )
                    );
                }
            },
            (error) => {
                this.matSnackBarOpen(
                    this.translateService.instant(
                        "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                    )
                );
            }
        );
    }

    remove(item) {
        this.documentManagerService.changeworkingState("busy");
        this.documentManagerService
            .RemoveObject(item, item.OrganizationId,this.dmsConfig.actionOnShared)
            .then(
                (response) => {
                    this.documentManagerService.changeworkingState("busy");
                    if (
                        response.StatusCode === 0 ||
                        response.statusCode === 0
                    ) {
                        if (item.Type === "DriveFile") {
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FILE_REMOVED"
                                )
                            );
                        } else {
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_REMOVED"
                                )
                            );
                        }
                        this.documentManagerService.onFileRemove.next({
                            Status: true,
                        });
                    } else {
                        this.matSnackBarOpen(
                            this.translateService.instant(
                                "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                            )
                        );
                    }
                },
                (error) => {
                    this.documentManagerService.changeworkingState("idle");
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                        )
                    );
                }
            );
    }

    changeColor(color, Folder, index) {
        this.documentManagerService.changeworkingState("busy");
        this.documentManagerService
            .ChangeFolderColor(Folder["ItemId"], color)
            .then(
                (response) => {
                    this.documentManagerService.changeworkingState("idle");
                    this.MyDrive.Folders.forEach((folder) => {
                        if (Folder["ItemId"] === folder.ItemId) {
                            folder.Color = color;
                        }
                    });
                    // this.dataSource[index]['Color'] = color;
                    // this.init()
                    // this.Folder.Color = color;
                },
                (error) => {
                    this.documentManagerService.changeworkingState("idle");
                    console.log(error);
                    this.matSnackBarOpen(
                        this.translateService.instant(
                            "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                        )
                    );
                }
            );
    }
    addOrRemoveFavourite(Folder){
        console.log(Folder)
            let itemId: any;
            if (Folder.Name) {
                if (Folder.Type === "SharedFolder") {
                    itemId = Folder.OriginalObjectArtifactId;
                } else if (Folder.Type === "DriveFolder") {
                    itemId = Folder.ItemId;
                }
                else if (Folder.Type === "DriveFile") {
                    itemId = Folder.ItemId;
                }
                this.documentManagerService.changeworkingState("busy");
                this.documentManagerService
                    .AddOrRemoveFavorite(
                        itemId,
                        Folder.IsFavorite,
                        Folder.FileStorageId,
                        Folder.Type
                    )
                    .then(
                        (response) => {
                            this.documentManagerService.changeworkingState(
                                "idle"
                            );
                            console.log(response)
                            if (
                                response.StatusCode === 0 ||
                                response.statusCode === 0
                            ) {
                                // this.matSnackBarOpen(
                                //     this.translateService.instant(
                                //         "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FOLDER_RENAMED"
                                //     )
                                // );
                                // this.documentManagerService.onFileRemove.next({
                                //     Status: true,
                                // });
                            } else {
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                                    )
                                );
                            }
                        },
                        (error) => {
                            this.documentManagerService.changeworkingState(
                                "idle"
                            );
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                                )
                            );
                        }
                    );
            }
    }
    ngOnDestroy() {
        // this.documentManagerService.FolderEvent.next("");
        this.documentManagerService.onShowDetail.next(null);
        this.FileRemoveSubscription.unsubscribe();
        this.TableChangeSubscription.unsubscribe();
    }

    rename(Folder) {
        let ext = "";
        if (Folder.Type === "DriveFile" || Folder.Type === "SharedFile") {
            ext = Folder.Name.split(".").pop();
        }
        const dialogRef = this.dialog.open(DocumentNewFolderDialogComponent, {
            width: "318px",
            data: {
                purpose: "rename",
                folderNameMinLength: 1,
                title: "Rename Folder",
                LanguageKey: "APP_PLATFORM_DOCUMENT_MANAGER.DMS_RENAME_FOLDER",
                name: Folder.Name.replace(/\.[^/.]+$/, ""),
            },
            disableClose: false,
        });
        dialogRef.afterClosed().subscribe((FolderName) => {
            let itemId: string;
            if (FolderName && FolderName.length > 0) {
                if (Folder.Type === "DriveFile") {
                    FolderName = FolderName + "." + ext;
                    itemId = Folder.ItemId;
                }
                if (Folder.Type === "SharedFolder") {
                    itemId = Folder.OriginalObjectArtifactId;
                } else if (Folder.Type === "DriveFolder") {
                    itemId = Folder.ItemId;
                }
                if (Folder.Type === "SharedFile") {
                    FolderName = FolderName + "." + ext;
                    itemId = Folder.OriginalArtifactId;
                }
                console.log(Folder.FileStorageId);

                this.documentManagerService.changeworkingState("busy");
                this.documentManagerService
                    .RenameObject(
                        itemId,
                        FolderName,
                        Folder.FileStorageId,
                        Folder.Type
                    )
                    .then(
                        (response) => {
                            this.documentManagerService.changeworkingState(
                                "idle"
                            );
                            if (
                                response.StatusCode === 0 ||
                                response.statusCode === 0
                            ) {
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        "APP_PLATFORM_DOCUMENT_MANAGER.DMS_FILE_RENAMED"
                                    )
                                );
                                this.documentManagerService.onFileRemove.next({
                                    Status: true,
                                });
                            } else {
                                this.matSnackBarOpen(
                                    this.translateService.instant(
                                        "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                                    )
                                );
                            }
                        },
                        (error) => {
                            this.documentManagerService.changeworkingState(
                                "idle"
                            );
                            this.matSnackBarOpen(
                                this.translateService.instant(
                                    "APP_PLATFORM_DOCUMENT_MANAGER.DMS_SOMETHING_WRONG_TRY_AGAIN"
                                )
                            );
                        }
                    );
            }
        });
    }
    matSnackBarOpen(value, duration?: number) {
        const translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: "top",
            horizontalPosition: "end",
            panelClass: "custom-snackbar",
        });
    }

    viewFile(item: DriveFile) {
        this.documentManagerService.viewFile(item, true);
    }
}
